<template>
    <div v-if="count" class="bulk-bar" role="region" :aria-label="'Actions for the ' + count + ' selected'">
        <b>{{ count }} selected</b>
        <span class="bulk-spacer"></span>
        <slot/>
        <el-button size="small" type="text" class="bulk-clear" @click="$emit('clear')">Clear</el-button>
    </div>
</template>

<script>
// Appears at the bottom of a list while rows are selected; the page supplies the buttons.
export default {
    name: "BulkBar",
    props: {count: {type: Number, default: 0}},
}
</script>

<style>
.bulk-bar {
    position: sticky;
    bottom: 12px;
    z-index: 20;
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
    margin: 14px 6px 0;
    padding: 10px 14px;
    border-radius: 12px;
    background: #14203F;
    color: #FFFFFF;
    box-shadow: 0 8px 24px rgba(20, 32, 63, .25);
}

.bulk-bar .el-button + .el-button,
.bulk-bar .el-dropdown {
    margin-left: 0;
}

.bulk-bar .bulk-spacer {
    flex: 1;
}

.bulk-bar .bulk-clear {
    color: #C9D3EA;
}

.el-dropdown-menu__item.danger-item {
    color: #B42318;
}
</style>
